import { getText, post } from "./networkService";

export async function getStripeApiKey() {
  return getText("/checkout/api-key");
}

export async function createStripeSession(invoices) {
  return post(`/checkout`, { invoices });
}
